@if (popupData) {

    <div>
@switch (data.type) {

        @case (orderTypes.coreReturnOrder) {
<app-core-return-order-popup
            
            [id]="data.id"
            [data]="popupData"
            [category]="popupData.category"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-core-return-order-popup>
}

        @case (orderTypes.damagedReturnOrder) {
<app-core-return-order-popup
            
            [id]="data.id"
            [data]="popupData"
            [category]="popupData.category"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-core-return-order-popup>
}

        @case (orderTypes.partsOrder) {
<app-parts-orders-popup 
            
            [id]="data.id"
            [data]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-parts-orders-popup>
}
        
        @case (orderTypes.purchaseOrder) {
<app-cart-checkout-popup 
           
            [recievedItems]="[popupData]"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-cart-checkout-popup>
}
        
        @case (orderTypes.serviceOrder) {
<app-popup
           
            [id]="data.id"
            [data]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-popup>
}
        
        @case (orderTypes.iscServiceOrder) {
<app-isc-popup
           
            [id]="data.id"
            [data]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-isc-popup>
}

        @case (orderTypes.returnOrder) {
<app-return-order-popup 
           
            [id]="data.id"
            [data]="popupData"
            [category]="popupData.category"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
            (onSave)="orderSaved($event)"
        ></app-return-order-popup>
}
        
        @case (orderTypes.shipmentOrder) {
<app-shipment-order-popup
           
            [id]="data.id"
            [data]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-shipment-order-popup>
}
        
        @case (orderTypes.adjustmentorder) {
<app-ms-dynamic-popup
           
            [tabName]="'details'"
            pageId="PG0000149"
            [orderId]="popupData.adjustmentOrderNumber"
            [data]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-ms-dynamic-popup>
}

        @case (orderTypes.cycleCountOrder) {
<app-cycle-counts-popup #cycleCountPopup 
           
            [cycleCountData]="popupData"
            [cycleCountId]="data.id"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-cycle-counts-popup>
}

        @case (orderTypes.purchaseOrder) {
<app-cart-checkout-popup
           
            [recievedItems]="popupData"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-cart-checkout-popup>
}

        @case (orderTypes.inventoryAdjustmentOrder) {
<app-shipment-adjustment-order-popup
           
            [data]="popupData"
            [orderId]="data.id"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-shipment-adjustment-order-popup>
}
        
        @case (orderTypes.transferOrder) {
<app-transfer-order-popup-opener
           
            [data]="data"
            (onLinkIdClick)="onLoopLinkClicked($event)"
            (onClose)="onClose()"
        ></app-transfer-order-popup-opener>
}
        @default {
<div></div>
}
    }
</div>    

}

@if (showLinkPopup) {
<app-linked-popup-opener
   
    [data]="data"
    (onLinkIdClick)="onLoopLinkClicked($event)"
    (onPopupClose)="showLinkPopup=false; data = null;"
></app-linked-popup-opener>
}